import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import { Toast, Button, Row, Col, Field,Cell, CellGroup, Tabbar, TabbarItem, Uploader, Picker,Popup,RadioGroup,Radio } from 'vant';
import tools from '@/utils/tools.js'
import cacheKit from '@/utils/cacheKit'
import addressInfo from '@/component/addressList'
import educationList from '@/component/educationList'
import { Stepper,Dialog} from 'vant';
import {DatePicker} from '@nutui/nutui';
import { NavBar } from 'vant';
import { Card } from 'vant';
import { PullRefresh } from 'vant';
import { List } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Image } from 'vant';
import { ImagePreview } from 'vant';
import { Tab, Tabs } from 'vant';
import { Notify } from 'vant';
import { Panel } from 'vant';
import { Divider } from 'vant';
import messageSocket from '@/utils/messageSocket.js'
import { Icon } from 'vant';
import { DropdownMenu, DropdownItem } from 'vant';
import wx from 'weixin-js-sdk'	
import { Switch } from 'vant';

Vue.use(Switch);
Vue.use(DropdownMenu).use(DropdownItem);
Vue.use(Icon);
Vue.use(Divider);
Vue.use(Panel);
Vue.use(Notify);
Vue.use(Tab).use(Tabs);
Vue.use(ImagePreview);
Vue.use(Image);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Card);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Uploader);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(addressInfo);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Cell);
Vue.use(Stepper);
Vue.use(Dialog);
Vue.use(DatePicker);

//注册组件
Vue.component("addressInfo", addressInfo);
Vue.component("educationList", educationList);

//=====================是否开发环境================================
let isDev = false;

Vue.config.productionTip = false;
Vue.prototype.$tools = tools;
Vue.prototype.$cacheKit = cacheKit;
Vue.prototype.$ImagePreview=ImagePreview;
//存放vue的页面组件
Vue.prototype.$pages={};
//全局数据
Vue.prototype.$globalData={};
Vue.prototype.$globalData.userInfo = cacheKit.get("userInfo");

var companyId = tools.getUrlParam("companyId");
// 在之后不需要 写 网址， uri了
if(isDev){
    Vue.prototype.baseURL = 'http://localhost:8088';
    if(!companyId){
        window.location.href = window.location.href +"?companyId=1";
    }

}else{
    //线上
    Vue.prototype.baseURL = 'https://td.ijjk.top';
    if(!companyId){
        window.location.href = window.location.href +"?companyId=1";
    }
    if(!tools.isWechat()){
        document.body.remove();
        document.head.remove();
    }
}


//设用平台
Vue.prototype.$globalData.platform = tools.getUrlParam("platform");

const axiosIns = tools.getAxios();
/**
 * 初始化获取地址
 */
axiosIns.post('/api/v1/user/addressList',{})
    .then(resp => {
       if(resp.code==0){
         let addressArr = resp.data;
         cacheKit.set("addressArr",addressArr,24*3600*365*100);
       }else{
            Toast(resp.msg);
       }
});
/**
 * 设置title
 */
axiosIns.post('/api/v1/user/getCompanyName',{id:companyId})
    .then(resp => {
       if(resp.code==0){
         document.title = resp.data;
       }else{
            console.debug(resp.msg);
       }
});


//开始Socket
let messageSocketUrl = Vue.prototype.baseURL+"/messageSocket/";
messageSocket.startSocket(messageSocketUrl);

Vue.prototype.$axios = axiosIns;
Vue.prototype.$messageSocket = messageSocket;
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js